<div class="filter-title">
  <div class="filter-name-wrapper" (click)="toggleFilter()" tabIndex="0" role="button" aria-hidden="true">
    @if (isCollapsable) {
      <rkt-icon class="filter-toggler" [name]="isCollapsed ? 'chevron-right' : 'chevron-down'"></rkt-icon>
    }
    <div class="filter-name">{{ filterName }}</div>
  </div>
  @if (selectedValue) {
    <button rktButton btnType="danger" class="filter-reset-btn" (click)="changed.emit()">Reset</button>
  }
</div>

@if (!isCollapsed) {
  <div class="rkt-form">
    <div class="rkt-form-field" [class.has-error]="filterInput.invalid">
      <div class="rkt-form-label">
        @if (props?.label) {
          <label [attr.for]="id"
            >{{ props?.label }}
            @if (props?.required) {
              <span class="asterisk">*</span>
            }
          </label>
        }
      </div>
      <div class="rkt-form-input-field">
        <input
          type="text"
          class="rkt-form-input"
          [pattern]="props?.validationPattern ?? ''"
          [maxlength]="props?.maxLength ?? null"
          [class.is-invalid]="filterInput.invalid"
          [formControl]="filterInput"
          (ngModelChange)="onInputChange($event)"
          [id]="'filter-item-input_' + id"
        />
      </div>
      @if (filterInput.invalid) {
        <div class="rkt-form-field-invalid-feedback">
          {{ props?.validationPatternMessage }}
        </div>
      }
    </div>
  </div>
}
